export enum MemberOrganizationsActions {
  Reset = "reset",
  FetchMemberOrganizations = "fetchMemberOrganizations",
  FetchMemberDepartment = "fetchMemberDepartment",
}
